import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { wishlistPageQueryOptions } from "~/app/api/pageData/wishlistPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createWishlistPage } from "~/pages/WishlistPage/WishlistPage";

function WishlistRoute() {
  const result = useLoaderData({
    from: "/wishlist",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createWishlistPage()}
    </StorefrontShellFrame>
  );
}

export async function loadWishlistPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(wishlistPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const wishlistRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/wishlist",
  loader: async ({ context }) => loadWishlistPageData(context),
  component: WishlistRoute,
});
